import React, { useContext, useEffect, useState } from 'react'
import {
    Carousel,
} from 'antd';
import {
    LeftOutlined,
    RightOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { _throttle } from "../../utils/util";
import './index.scss';

export default function CarouselView({ images = [] }) {

    const carouselRef = React.createRef()
        , topCarouselRef = React.createRef()
        , { serverUrl } = useSelector(state => state.siteInfo)

    const [selectedImageIndex, setSelectedImageIndex] = useState(0)         // 当前选中的图片index
        , [itemsPerPage, setItemsPerPage] = useState(4)                     // 每页显示的图片数量
        , [imgStyles, setImgStyles] = useState({})

    useEffect(() => {
        // 在组件加载后，为每张图片动态设置样式
        const newImgStyles = {};

        images.forEach((image, index) => {
            const img = new Image();
            img.src = image;
            img.onload = () => {
                if (img.width >= img.height) {
                    newImgStyles[index] = { width: '100%' };
                } else {
                    newImgStyles[index] = { height: '100%' };
                }

                // 如果是最后一张图片，将所有样式一次性更新
                if (index === images.length - 1) {
                    setImgStyles(newImgStyles);
                }
            };
        });
    }, []);

    useEffect(() => {
        if (topCarouselRef.current) {
            topCarouselRef.current.goTo(selectedImageIndex);
        }
    }, [selectedImageIndex, topCarouselRef])

    const handleNextClick = _throttle(() => {
        if (carouselRef.current) {
            const nextIndex = selectedImageIndex + 1;
            if (nextIndex < images.length) {
                // carouselRef.current.next();
                setSelectedImageIndex(nextIndex);                   // 更新选中的图片索引
                carouselRef.current.goTo(selectedImageIndex);       // 跳转到中的图片
            }
        }
    }, 1000)

    const handlePrevClick = _throttle(() => {
        if (carouselRef.current) {
            const prevIndex = selectedImageIndex - 1;
            if (prevIndex >= 0) {
                carouselRef.current.prev();
                setSelectedImageIndex(prevIndex);                   // 更新选中的图片索引
            }
        }
    }, 1000)

    const handleCarouselClick = (currentSlide) => {
        setSelectedImageIndex(currentSlide);
    };

    return (
        <div className='details-carousel'>

            <div
                className='top-carousel'
            >
                <Carousel
                    ref={topCarouselRef}
                    dots={false}
                >
                    {images.map((image, index) => (
                        <div
                            key={index}
                            className='img-container'
                        >
                            <img src={serverUrl + image} style={imgStyles[index]} alt='' />
                        </div>
                    ))}
                </Carousel>
            </div>

            <div className="thumbnail-carousel">
                <div
                    className='carousel-arrow left-arrow'
                    onClick={handlePrevClick}
                >
                    <LeftOutlined />
                </div>

                <div className='thumbnail-carousel-content'>
                    <Carousel
                        ref={carouselRef}
                        dots={false}
                        slidesToShow={itemsPerPage}         // 每页显示4个图片
                        slidesToScroll={itemsPerPage}       // 每次滚动4个图片
                        infinite={false}                    // 禁用无限滚动
                    >
                        {images.map((image, index) => (
                            <div
                                key={index}
                                onClick={() => handleCarouselClick(index)}
                            >
                                <img
                                    className={`thumbnail-img ${index === selectedImageIndex ? 'thumbnail-img-select' : ''}`}
                                    src={serverUrl + image}
                                    alt={`Thumbnail ${index + 1}`}
                                />
                            </div>
                        ))}
                    </Carousel>
                </div>

                <div
                    className='carousel-arrow right-arrow'
                    onClick={handleNextClick}
                >
                    <RightOutlined />
                </div>
            </div>
        </div>
    )
}
